import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "ec-cf97f8ad-604a-4e41-a151-2836220ab398-__Layer_1",
  "enable-background": "new 0 0 72 72",
  height: "512",
  viewBox: "0 0 72 72",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"ec-ce7d62c7-903b-45ea-82f2-479843dbff50-__Layer_2_1_\"><g id=\"ec-c6d91124-90f7-487a-bc9c-24b3729cf531-__Layer_1-2\"><g id=\"ec-5bd7b365-aa21-438c-8f38-e5bdb635eaa3-__format_strikethrough\"><path d=\"m58 36h-44c-1.7 0-3 1.3-3 3s1.3 3 3 3h19v18h-6c-1.7 0-3 1.3-3 3s1.3 3 3 3h18c1.7 0 3-1.3 3-3s-1.3-3-3-3h-6v-18h19c1.7 0 3-1.3 3-3s-1.3-3-3-3z\"></path><path d=\"m60 6h-48c-1.7 0-3 1.3-3 3v8c0 1.7 1.3 3 3 3s3-1.3 3-3v-5h18v17.6c0 1.7 1.3 3 3 3s3-1.3 3-3v-17.6h18v5c0 1.7 1.3 3 3 3s3-1.3 3-3v-8c0-1.7-1.3-3-3-3z\"></path></g></g></g>", 1)
  ]))]))
}
export default { render: render }